import { arrayContains } from 'utils';
import { ATTEND_INSURANCE_COOPERATION_USER_DATA_REQUEST } from 'redux/actions';

export const isAttendUserToInsuranceCooperationLoading = (state) =>
  arrayContains(state.entities.users.openRequests, [ATTEND_INSURANCE_COOPERATION_USER_DATA_REQUEST]);
